<template>
  <div class="cabecalho-da-solicitacao">
    <div class="cabecalho-da-solicitacao__linha">
      <div class="cabecalho-da-solicitacao__identificacao">
        <span class="titulo titulo_mini cabecalho-da-solicitacao__rotulo">
          Subsídio da AGEHAB
        </span>
        <span class="titulo titulo_grande cabecalho-da-solicitacao__titular">
          {{ nomeDoTitular }}
        </span>
      </div>

      <div class="no-print cabecalho-da-solicitacao__acoes">
        <template v-for="acao in acoesDaSituacao">
          <span
            v-if="acao.impedida"
            :key="acao.chave + '-impedida'"
            class="dica"
          >
            <button
              type="button"
              disabled
              class="botao botao_medio botao_cor-primaria botao_com-icone-para-esquerda"
            >
              <i :class="acao.icone" aria-hidden="true"></i>
              {{ acao.rotulo }}
            </button>
            <span
              class="dica__conteudo dica__conteudo_inferior dica__conteudo_medio"
            >
              {{ acao.impedimento.mensagem }}
            </span>
          </span>
          <button
            v-else
            :key="acao.chave + '-disponivel'"
            type="button"
            @click="$emit('executar-acao', acao)"
            class="botao botao_medio botao_cor-primaria botao_com-icone-para-esquerda"
            :class="{ botao_contorno: !acao.destaque }"
          >
            <i :class="acao.icone" aria-hidden="true"></i>
            {{ acao.rotulo }}
          </button>
        </template>

        <button
          v-if="podeAutorizarPagamento"
          type="button"
          @click="$emit('abrir-pagamento')"
          class="no-print botao botao_medio botao_cor-primaria botao_com-icone-para-esquerda"
        >
          <i class="fa fa-dollar-sign" aria-hidden="true"></i>
          Liquidar
        </button>

        <div class="dropdown dropdown_direita">
          <button
            type="button"
            aria-haspopup="true"
            aria-label="Mais ações"
            class="botao botao_medio botao_icone botao_sem-preenchimento cabecalho-da-solicitacao__mais-acoes"
            :class="{
              'cabecalho-da-solicitacao__mais-acoes_destacado':
                acoesDaSituacao.length === 0,
            }"
          >
            <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
          </button>
          <ul class="dropdown__lista" aria-label="Submenu">
            <li v-if="podeEditar" class="dropdown__item">
              <button
                type="button"
                @click="$emit('editar')"
                class="dropdown__link"
              >
                <i class="far fa-pencil dropdown__icone" aria-hidden="true"></i>
                Editar
              </button>
            </li>
            <li class="dropdown__item">
              <button
                type="button"
                onclick="window.print()"
                class="dropdown__link"
              >
                <i class="far fa-print dropdown__icone" aria-hidden="true"></i>
                Imprimir resumo
              </button>
            </li>
            <li v-if="podeAlterarNup" class="dropdown__item">
              <button
                type="button"
                @click="$emit('abrir-alteracao-nup')"
                class="dropdown__link"
              >
                <i
                  class="far fa-pencil-alt dropdown__icone"
                  aria-hidden="true"
                ></i>
                Alterar NUP
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <span
      class="titulo titulo_medio titulo_cor-primaria cabecalho-da-solicitacao__valor"
    >
      {{ subsidioDaAgehab }}
    </span>

    <linha-do-tempo-da-solicitacao
      v-if="solicitacaoEhDoBonusMoradia"
      :linha-do-tempo="linhaDoTempo"
    />
  </div>
</template>

<script>
import LinhaDoTempoDaSolicitacao from "./LinhaDoTempoDaSolicitacao";

export default {
  name: "cabecalho-da-solicitacao",
  components: { LinhaDoTempoDaSolicitacao },
  props: {
    nomeDoTitular: { type: String, default: "" },
    subsidioDaAgehab: { type: String, default: "" },
    acoesDaSituacao: { type: Array, default: () => [] },
    podeAutorizarPagamento: { type: Boolean, default: false },
    podeEditar: { type: Boolean, default: false },
    podeAlterarNup: { type: Boolean, default: false },
    solicitacaoEhDoBonusMoradia: { type: Boolean, default: false },
    linhaDoTempo: { type: Object, default: null },
  },
};
</script>



// WEBPACK FOOTER //
// CabecalhoDaSolicitacao.vue?5a3c24fa